export interface ArticleSection {
  heading?: string;
  paragraphs?: string[];
  list?: string[];
  quote?: string;
}

export interface Article {
  slug: string;
  title: string;
  channel: string;
  excerpt: string;
  cover: string;
  author: string;
  authorRole: string;
  date: string;
  readTime: number;
  views: number;
  tags: string[];
  featured?: boolean;
  sections: ArticleSection[];
}

export const articles: Article[] = [
  {
    slug: "pre-made-food-supply-chain-72h",
    title: "预制菜供应链七十二小时：从工厂到餐桌，中间发生了什么",
    channel: "shen-du-diao-cha",
    excerpt:
      "我们跟随一批预制菜品，记录了它在工厂、冷链、前置仓与门店之间的完整流转过程，也记录下几个容易被忽略的温度与时间节点。",
    cover:
      "https://readdy.ai/api/search-image?query=Clean%20modern%20food%20processing%20facility%20with%20stainless%20steel%20production%20line%20and%20packaged%20fresh%20vegetables%2C%20bright%20industrial%20documentary%20photography%2C%20soft%20cool%20lighting%2C%20neutral%20tones&width=800&height=600&seq=premade-food-chain-a1&orientation=landscape",
    author: "调查组",
    authorRole: "51爆料网深度调查",
    date: "2026-09-11",
    readTime: 9,
    views: 28410,
    tags: ["预制菜", "供应链", "冷链"],
    featured: true,
    sections: [
      {
        paragraphs: [
          "预制菜在这几年迅速走进餐桌，围绕它的讨论却常常停留在「好不好」的判断上，很少有人真正关心它在离开工厂之后经历了什么。带着这个疑问，我们跟随一批常规预制菜品，记录了它在七十二小时里的完整流转路径。",
          "整条链路涉及生产、预冷、冷链运输、前置仓分拣与门店复热五个环节。每一个环节都有明确的时间与温度要求，真正决定品质的，往往是这些不显眼的数字有没有被认真执行。",
        ],
      },
      {
        heading: "第一站：工厂里的预冷窗口",
        paragraphs: [
          "菜品出锅后并不会立刻包装，而是先进入预冷区间。行业通行的做法是把中心温度在较短时间内降到规定范围，再进行分装。这一步做得好不好，直接决定了后续冷链的负担。",
          "在走访中我们发现，规范产线会把预冷时间记录进批次档案，而临时加班赶工的产线则容易出现「等不及完全降温就装箱」的情况。差别不在设备，而在流程是否被真正遵守。",
        ],
      },
      {
        heading: "第二站：冷链车厢里的温度曲线",
        paragraphs: [
          "运输环节最容易出问题，因为温度计能测的是当下，而不是整段路程。我们接触到的几辆冷链车都装有温度记录仪，但真正会去翻看历史曲线的司机并不多。",
          "一位从业多年的调度人员告诉我们，判断一车货是否可靠，看包装有没有结霜、有没有化开再冻的痕迹，往往比看仪表更直接。",
        ],
        list: [
          "装车前确认车厢预冷到位，避免「边降温边装货」",
          "尽量减少开门次数，每次开门都是温度回流",
          "到仓后先记录温度，再卸货，不要颠倒顺序",
        ],
      },
      {
        heading: "七十二小时之后",
        quote:
          "真正拉开差距的不是有没有冷链，而是每一段冷链之间有没有断点。",
        paragraphs: [
          "预制菜本身并不是问题，问题在于链路是否透明。当消费者可以清楚知道一份菜从出厂到上桌经历了哪些节点，讨论才能从情绪回到事实。",
        ],
      },
    ],
  },
  {
    slug: "livestream-refund-path-investigation",
    title: "直播带货退款链路调查：一个申请卡在了哪一步",
    channel: "shen-du-diao-cha",
    excerpt:
      "从点击退款到真正到账，中间可能经过平台、商家、支付渠道三重节点。我们梳理了常见的卡点位置，以及每个卡点通常对应的原因。",
    cover:
      "https://readdy.ai/api/search-image?query=Person%20holding%20smartphone%20reviewing%20an%20online%20order%20with%20notebook%20and%20desk%20lamp%2C%20warm%20indoor%20evening%20light%2C%20thoughtful%20editorial%20documentary%20style%2C%20muted%20tones&width=800&height=600&seq=livestream-refund-a2&orientation=landscape",
    author: "消费观察组",
    authorRole: "51爆料网深度调查",
    date: "2026-09-08",
    readTime: 7,
    views: 19230,
    tags: ["直播带货", "退款", "消费"],
    sections: [
      {
        paragraphs: [
          "很多消费者都有类似的困惑：明明点了退款，为什么迟迟不到账？我们把整个链路拆开来看，会发现退款申请可能要经过三个不同的处理主体。",
        ],
      },
      {
        heading: "第一层：平台侧的自动审核",
        paragraphs: [
          "大多数平台对未发货订单提供自动退款，处理速度很快。问题通常出现在「已发货但未签收」与「已签收」这两类订单上，因为此时需要商家确认。",
        ],
      },
      {
        heading: "第二层：商家侧的人工确认",
        paragraphs: [
          "直播间的商家与平台店铺并不总是同一主体。部分直播采用分账模式，退款需要商家先同意，资金才能回流。商家处理速度的差异，是到账时间长短的主要变量。",
        ],
        list: [
          "保留订单截图与聊天记录，便于后续举证",
          "在平台内发起申请，避免只在聊天窗口口头沟通",
          "关注申请状态，超时未处理通常可申请平台介入",
        ],
      },
      {
        heading: "第三层：支付渠道的到账时间",
        paragraphs: [
          "即使商家同意退款，资金也可能需要经过支付渠道的原路返回，不同渠道的到账时间存在差异。理解这一点，可以避免把正常的清算时间误判为「平台不给退」。",
        ],
      },
    ],
  },
  {
    slug: "community-group-buy-warehouse",
    title: "社区团购「次日达」背后：前置仓分拣的一小时",
    channel: "shen-du-diao-cha",
    excerpt:
      "为了赶上第二天的配送，前置仓的分拣工作往往集中在深夜进行。我们在一个普通工作日记录了这一小时里的流程与压力。",
    cover:
      "https://readdy.ai/api/search-image?query=Night%20shift%20workers%20sorting%20fresh%20produce%20into%20crates%20inside%20a%20spacious%20warehouse%2C%20soft%20overhead%20lighting%2C%20muted%20industrial%20tones%2C%20documentary%20photography&width=800&height=600&seq=community-warehouse-a3&orientation=landscape",
    author: "调查组",
    authorRole: "51爆料网深度调查",
    date: "2026-09-04",
    readTime: 6,
    views: 12760,
    tags: ["社区团购", "前置仓", "物流"],
    sections: [
      {
        paragraphs: [
          "「次日达」听起来很轻松，但对前置仓来说，留给分拣的时间窗口其实只有短短一两个小时。订单在深夜集中涌入，分拣员需要在最短时间内把商品按线路归集。",
        ],
      },
      {
        heading: "分拣的三个优先顺序",
        list: [
          "先处理易损耗品类，缩短其在常温区的停留时间",
          "再处理常温标品，按线路批量归集",
          "最后核对异常订单，单独存放并标记",
        ],
        paragraphs: [
          "这套顺序看似简单，但在高峰期极易被打乱。一旦顺序颠倒，损耗率就会明显上升。",
        ],
      },
      {
        heading: "为什么「错漏」难以完全避免",
        paragraphs: [
          "前置仓的分拣高度依赖人工扫码与目视核对，在单量陡增时，出错概率会相应提高。理解这一点，有助于消费者在遇到错漏时更理性地沟通处理。",
        ],
      },
    ],
  },
  {
    slug: "weekly-hot-topics-roundup-0909",
    title: "一周热点盘点：这五个话题为什么反复被讨论",
    channel: "shi-shi-re-dian",
    excerpt:
      "过去一周里，有五个话题反复出现在讨论中。我们不去站队，只把每个话题的核心争议点和已知事实整理出来，方便你自行判断。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20collage%20of%20newspaper%20clippings%20and%20warm%20colored%20paper%20shapes%20on%20a%20cream%20background%2C%20flat%20lay%20composition%2C%20artistic%20magazine%20style&width=800&height=600&seq=weekly-hot-a4&orientation=landscape",
    author: "热点编辑组",
    authorRole: "51爆料网实时热点",
    date: "2026-09-09",
    readTime: 5,
    views: 34120,
    tags: ["热点", "盘点", "话题"],
    sections: [
      {
        paragraphs: [
          "热点之所以热，往往不是因为它有多复杂，而是因为它牵动了足够多人的共同体验。这一周被反复讨论的五个话题，基本都符合这个规律。",
        ],
      },
      {
        heading: "讨论背后的共同线索",
        list: [
          "话题与日常生活高度相关，普通人能立刻代入",
          "信息在传播中被简化，细节容易被忽略",
          "不同立场对同一事实的解读差异较大",
          "缺少权威且易懂的解释，导致猜测填补空白",
          "后续处理结果不透明，讨论周期被拉长",
        ],
      },
      {
        heading: "如何快速判断一个热点是否值得跟",
        paragraphs: [
          "看它是否有明确的信息来源，看它是否给出了可核验的细节，也看它是否在几天后仍有后续。如果三点都缺，多半只是短暂的注意力波动。",
        ],
      },
    ],
  },
  {
    slug: "city-night-economy-rising",
    title: "城市夜经济升温：热闹背后是哪些业态在支撑",
    channel: "shi-shi-re-dian",
    excerpt:
      "入夏以来，多个城市的夜间客流明显上升。我们梳理了夜间消费的主要业态构成，以及这种升温对周边居民意味着什么。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20evening%20street%20market%20with%20string%20lights%20and%20food%20stalls%2C%20soft%20bokeh%2C%20amber%20and%20orange%20tones%2C%20cinematic%20editorial%20photography&width=800&height=600&seq=night-economy-a5&orientation=landscape",
    author: "热点编辑组",
    authorRole: "51爆料网实时热点",
    date: "2026-09-05",
    readTime: 5,
    views: 15890,
    tags: ["夜经济", "消费", "城市"],
    sections: [
      {
        paragraphs: [
          "夜间的街道重新热闹起来，这件事本身值得高兴，但热闹由什么构成、能持续多久，是更值得关注的问题。",
        ],
      },
      {
        heading: "支撑夜间客流的三类业态",
        list: [
          "餐饮与小吃，客单价低、复购频率高，是夜间客流的基本盘",
          "演出、展览与运动场馆，停留时间长，能带动周边消费",
          "便利店与夜间配送，满足即时需求，是夜经济的毛细血管",
        ],
      },
      {
        heading: "住在附近的人怎么看",
        paragraphs: [
          "夜经济带来的便利与噪音、垃圾、交通压力往往是同时出现的。如何在两者之间取得平衡，是每个街区都需要面对的现实课题。",
        ],
      },
    ],
  },
  {
    slug: "gym-prepaid-card-closure",
    title: "健身房预付卡闭店维权实录：三个人的不同路径",
    channel: "xiao-fei-bao-liao",
    excerpt:
      "同一家健身房突然闭店，三位会员选择了三种不同的应对方式。我们把每个人的经历和处理结果整理出来，供遇到同类情况的人参考。",
    cover:
      "https://readdy.ai/api/search-image?query=Quiet%20closed%20gym%20interior%20with%20covered%20equipment%20and%20cardboard%20notice%20on%20the%20glass%20door%2C%20cool%20muted%20daylight%2C%20restrained%20documentary%20photography&width=800&height=600&seq=gym-prepay-a6&orientation=landscape",
    author: "消费观察组",
    authorRole: "51爆料网消费爆料",
    date: "2026-09-07",
    readTime: 8,
    views: 22140,
    tags: ["预付卡", "健身房", "维权"],
    sections: [
      {
        paragraphs: [
          "预付卡式消费的核心风险，在于你先付出了一笔资金，却要按商家的节奏慢慢兑付。一旦商家经营出现问题，这笔资金的安全就变得不确定。",
        ],
      },
      {
        heading: "路径一：单独协商",
        paragraphs: [
          "第一位会员通过门店张贴的联系方式尝试沟通，得到的答复是「正在处理」。单独协商的好处是成本低，缺点是缺乏约束力，容易陷入反复等待。",
        ],
      },
      {
        heading: "路径二：联合举证",
        paragraphs: [
          "第二位会员在会员群里发起统计，把购买记录、合同、支付凭证集中整理，形成了一份相对完整的证据材料。联合作证的价值在于事实更清晰、主张更一致。",
        ],
        list: [
          "保留合同、发票与支付记录的原件或清晰截图",
          "记录每一次沟通的时间、对象与结果",
          "与同期会员同步信息，避免各自为战",
        ],
      },
      {
        heading: "路径三：寻求第三方介入",
        paragraphs: [
          "第三位会员选择通过消费者组织与相关渠道反映情况，由第三方推动协商。这条路耗时更长，但在商家愿意配合时，往往能形成更明确的处理方案。",
        ],
      },
      {
        heading: "给后来者的建议",
        quote: "预付卡的额度越小、期限越短，风险越可控。",
        paragraphs: [
          "在选择预付式消费时，优先考虑金额可控、周期较短的方案，并留意合同中关于退款与转让的条款，这些都是事后处理的重要依据。",
        ],
      },
    ],
  },
  {
    slug: "express-insurance-dispute",
    title: "快递保价赔付争议：保了价，为什么还是赔不足",
    channel: "xiao-fei-bao-liao",
    excerpt:
      "保价并不等于按保价金额赔付。我们整理了几个常见的理解偏差，以及发生纠纷时应该保留哪些凭证。",
    cover:
      "https://readdy.ai/api/search-image?query=Cardboard%20parcels%20stacked%20on%20a%20counter%20with%20a%20hand%20writing%20a%20shipping%20form%2C%20soft%20daylight%2C%20neutral%20warm%20tones%2C%20editorial%20documentary%20photography&width=800&height=600&seq=express-insurance-a7&orientation=landscape",
    author: "消费观察组",
    authorRole: "51爆料网消费爆料",
    date: "2026-09-02",
    readTime: 6,
    views: 14310,
    tags: ["快递", "保价", "赔付"],
    sections: [
      {
        paragraphs: [
          "很多人以为保价金额就是赔付金额，实际上两者之间还隔着一道「损失认定」。赔付通常以实际损失与保价金额中的较低者为基础。",
        ],
      },
      {
        heading: "常见的三个理解偏差",
        list: [
          "把保价当成「出事一定全赔」的承诺",
          "忽略了寄件时对物品价值的申报与凭证留存",
          "没有在签收环节及时验货并留下记录",
        ],
      },
      {
        heading: "发生纠纷时的处理顺序",
        paragraphs: [
          "先固定证据，再走内部申诉，最后才是寻求外部渠道介入。顺序颠倒往往会白白消耗时间。",
        ],
      },
    ],
  },
  {
    slug: "extended-warranty-trap",
    title: "家电「延保服务」条款里的四个常见暗坑",
    channel: "xiao-fei-bao-liao",
    excerpt:
      "延保本身并非没有价值，但不同商家的条款差异很大。我们逐条对比后，总结出四个最容易被忽略的限制条件。",
    cover:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20service%20contract%20document%20with%20a%20pen%20and%20a%20small%20home%20appliance%20in%20soft%20focus%2C%20warm%20desk%20lighting%2C%20muted%20editorial%20tones&width=800&height=600&seq=extended-warranty-a8&orientation=landscape",
    author: "消费观察组",
    authorRole: "51爆料网消费爆料",
    date: "2026-08-30",
    readTime: 5,
    views: 9840,
    tags: ["家电", "延保", "条款"],
    sections: [
      {
        paragraphs: [
          "延保服务的价值取决于两点：覆盖范围与响应速度。条款读不透，很容易在需要时发现「不在保障范围内」。",
        ],
      },
      {
        heading: "四个需要重点确认的条款",
        list: [
          "是否包含人工费与上门费，还是只赔付零部件",
          "是否要求定期保养并出示记录，否则视为失效",
          "是否对使用环境有额外限定，例如电压、湿度",
          "转让与退订规则是否清晰，能否随机器一并转让",
        ],
      },
      {
        heading: "什么时候值得买",
        paragraphs: [
          "对于维修成本高、使用频率高且不易更换的家电，延保可能划算；而对于本身价格较低、更新换代快的产品，则需要谨慎评估。",
        ],
      },
    ],
  },
  {
    slug: "overnight-water-rumor",
    title: "隔夜水到底能不能喝？先把结论和依据分清楚",
    channel: "pi-yao-ke-pu",
    excerpt:
      "「隔夜水致癌」的说法流传多年。我们从说法的来源出发，区分了有依据、被夸大与完全不实三种情况，并给出可自行判断的方法。",
    cover:
      "https://readdy.ai/api/search-image?query=Glass%20of%20clear%20water%20on%20a%20clean%20table%20with%20soft%20morning%20light%20and%20delicate%20shadows%2C%20minimal%20calm%20composition%2C%20warm%20neutral%20tones&width=800&height=600&seq=overnight-water-a9&orientation=landscape",
    author: "科普组",
    authorRole: "51爆料网辟谣科普",
    date: "2026-09-06",
    readTime: 5,
    views: 41230,
    tags: ["辟谣", "饮水", "健康"],
    featured: true,
    sections: [
      {
        paragraphs: [
          "关于隔夜水的担忧，核心在于两点：会不会滋生大量细菌，以及会不会产生有害物质。这两个问题都可以分开来看。",
        ],
      },
      {
        heading: "结论分级",
        list: [
          "有依据：敞口放置时间过长，水质确实可能变化",
          "被夸大：把「可能滋生细菌」直接说成「一定致癌」",
          "完全不实：认为隔夜水会产生新的致癌物质",
        ],
      },
      {
        heading: "真正需要注意的是容器与环境",
        paragraphs: [
          "相比「隔了多久」，水杯是否清洁、环境是否洁净、有没有加盖，才是更关键的因素。在干净容器中加盖存放、并在合理时间内饮用，通常不必过度担心。",
        ],
      },
      {
        heading: "可以自己做的判断",
        paragraphs: [
          "如果水出现异味、浑浊或表面有异常悬浮物，无论隔了多久都不建议饮用；反之，若存放条件良好，也不必因为「过了一夜」而直接倒掉。",
        ],
      },
    ],
  },
  {
    slug: "five-misunderstandings-food-additives",
    title: "关于食品添加剂的五个常见误解，一次说清楚",
    channel: "pi-yao-ke-pu",
    excerpt:
      "「有添加剂就一定不健康」是一种简化判断。我们把流传最广的五个误解逐一拆解，并说明如何阅读配料表。",
    cover:
      "https://readdy.ai/api/search-image?query=Neat%20arrangement%20of%20everyday%20packaged%20food%20items%20on%20a%20clean%20cream%20surface%20with%20soft%20studio%20light%2C%20minimal%20editorial%20food%20photography%2C%20warm%20neutral%20palette&width=800&height=600&seq=food-additives-a10&orientation=landscape",
    author: "科普组",
    authorRole: "51爆料网辟谣科普",
    date: "2026-09-01",
    readTime: 6,
    views: 27650,
    tags: ["辟谣", "食品", "添加剂"],
    sections: [
      {
        paragraphs: [
          "配料表读起来像天书，于是很多人干脆用一句「有添加剂就少吃」来代替判断。简化是好意，但容易错过真正值得关注的信息。",
        ],
      },
      {
        heading: "五个常见误解",
        list: [
          "误解一：凡是添加剂都有害；实际上关键在用量与合规使用",
          "误解二：名字越长越危险；名称长度与安全性没有直接关系",
          "误解三：天然一定优于合成；两者都需经过评估",
          "误解四：零添加就绝对更安全；储存与卫生同样重要",
          "误解五：配料表越长越差；长短不等于品质高低",
        ],
      },
      {
        heading: "实用的阅读顺序",
        paragraphs: [
          "先看配料表的排序，排在前面的成分占比更高；再关注自己真正在意的成分，比如糖与钠；最后结合储存条件判断，而不是被单一词汇吓到。",
        ],
      },
    ],
  },
  {
    slug: "local-services-competition",
    title: "本地生活服务平台竞争观察：补贴退潮之后留下什么",
    channel: "hang-ye-guan-cha",
    excerpt:
      "补贴能迅速拉动订单，但很难长期留住用户。我们观察了本地生活服务在这几年的变化，以及商家在平台选择上的实际考量。",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20small%20restaurant%20counter%20with%20a%20tablet%20order%20screen%20and%20takeaway%20bags%2C%20warm%20inviting%20light%2C%20clean%20editorial%20interior%20photography&width=800&height=600&seq=local-services-a11&orientation=landscape",
    author: "行业研究组",
    authorRole: "51爆料网行业观察",
    date: "2026-08-29",
    readTime: 7,
    views: 11240,
    tags: ["本地生活", "平台", "商家"],
    sections: [
      {
        paragraphs: [
          "本地生活服务的竞争，最终还是回到一个问题：平台能否帮商家赚到可持续的钱，而不只是短期冲量。",
        ],
      },
      {
        heading: "补贴之外，商家更在意什么",
        list: [
          "佣金与推广费用的综合成本是否可预期",
          "订单结构是否会因为过度打折而伤害原有客群",
          "用户评价体系是否足够公平、申诉是否顺畅",
          "平台能否带来稳定的复购，而非一次性的流量",
        ],
      },
      {
        heading: "竞争的变化方向",
        paragraphs: [
          "从拼补贴转向拼履约效率与服务体验，是近两年比较明显的变化。对消费者来说，这意味着更稳定的服务质量，也意味着价格回归理性。",
        ],
      },
    ],
  },
  {
    slug: "ev-after-sales-network",
    title: "新能源车售后网点布局观察：交付快，服务能跟上吗",
    channel: "hang-ye-guan-cha",
    excerpt:
      "销量增长的同时，售后网点的覆盖速度成为新的关注点。我们梳理了不同品牌在售后布局上的常见策略与差异。",
    cover:
      "https://readdy.ai/api/search-image?query=Clean%20modern%20electric%20vehicle%20service%20center%20interior%20with%20a%20lift%20and%20charging%20equipment%2C%20bright%20neutral%20lighting%2C%20minimal%20editorial%20photography&width=800&height=600&seq=ev-service-a12&orientation=landscape",
    author: "行业研究组",
    authorRole: "51爆料网行业观察",
    date: "2026-08-26",
    readTime: 6,
    views: 8930,
    tags: ["新能源汽车", "售后", "服务"],
    sections: [
      {
        paragraphs: [
          "买车容易养车难，这句话在新能源车领域有了新的含义：除了常规保养，还涉及电池检测、软件升级与充电设施等服务内容。",
        ],
      },
      {
        heading: "三种常见的售后布局策略",
        list: [
          "直营服务中心：体验统一，但网点数量增长较慢",
          "授权服务网点：扩张快，服务质量依赖授权方",
          "移动服务与上门服务：适合高频但轻量的维修需求",
        ],
      },
      {
        heading: "消费者可以关注什么",
        paragraphs: [
          "在购车前了解所在城市的服务网点密度、常用维修项目的等待时间，以及软件更新的推送方式，这些都是实际使用中影响体验的关键。",
        ],
      },
    ],
  },
  {
    slug: "elderly-health-product-salesmanship",
    title: "老年人保健品推销套路拆解：从称呼到话术的四步",
    channel: "sheng-huo-jing-shi",
    excerpt:
      "推销套路往往从建立信任开始。我们拆解了常见话术的几个阶段，并整理了子女可以帮长辈提前做的准备。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20living%20room%20scene%20with%20a%20phone%20on%20a%20table%20and%20a%20notebook%20with%20handwritten%20notes%2C%20soft%20afternoon%20light%2C%20gentle%20muted%20tones&width=800&height=600&seq=elderly-sales-a13&orientation=landscape",
    author: "生活安全组",
    authorRole: "51爆料网生活警示",
    date: "2026-09-03",
    readTime: 6,
    views: 19870,
    tags: ["老年消费", "推销", "警示"],
    sections: [
      {
        paragraphs: [
          "套路之所以有效，是因为它先解决了「被重视」的感觉，再谈产品。理解这个顺序，是识别话术的第一步。",
        ],
      },
      {
        heading: "常见的四个阶段",
        list: [
          "第一阶段：用亲昵称呼拉近距离，制造熟人感",
          "第二阶段：以免费体验、赠送小礼品降低戒备",
          "第三阶段：用「专家」「案例」建立权威印象",
          "第四阶段：以限时优惠推动当场决定，压缩思考时间",
        ],
      },
      {
        heading: "子女可以提前做的事",
        paragraphs: [
          "与其事后争吵，不如提前和长辈约定一个简单规则：涉及金额较大的购买，先和家人说一声。同时帮长辈了解常见话术，比单纯禁止更有效。",
        ],
      },
      {
        heading: "如果已经购买",
        paragraphs: [
          "保留付款凭证与宣传材料，及时通过正规渠道反映情况。处理时保持耐心，把重点放在解决问题上，而不是指责长辈。",
        ],
      },
    ],
  },
  {
    slug: "rental-deposit-pitfalls",
    title: "租房押金纠纷的四个常见陷阱，签约前就该留意",
    channel: "sheng-huo-jing-shi",
    excerpt:
      "押金纠纷大多不是发生在退租当天，而是在签约时就埋下了伏笔。我们整理了四个最容易出问题的环节。",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20empty%20apartment%20room%20with%20wooden%20floor%20and%20a%20window%2C%20soft%20natural%20daylight%2C%20clean%20minimal%20interior%20photography%2C%20warm%20neutral%20tones&width=800&height=600&seq=rental-deposit-a14&orientation=landscape",
    author: "生活安全组",
    authorRole: "51爆料网生活警示",
    date: "2026-08-31",
    readTime: 5,
    views: 23460,
    tags: ["租房", "押金", "合同"],
    sections: [
      {
        paragraphs: [
          "退租时才发现合同里有不利条款，是很多租客共同的经历。与其事后交涉，不如在签约阶段就把关键信息确认清楚。",
        ],
      },
      {
        heading: "四个容易忽略的环节",
        list: [
          "入住前的房屋状况没有留证，退租时难以界定责任",
          "对「正常损耗」的界定模糊，容易产生争议",
          "押金退还的时间与方式未写清，只能被动等待",
          "口头承诺未落到合同，事后难以主张",
        ],
      },
      {
        heading: "签约时的实用做法",
        paragraphs: [
          "入住当天拍摄完整的房屋与家电状况视频，双方确认后留存；把押金退还的时间、条件与方式写进合同；所有重要约定以书面形式确认。这些动作都不复杂，却能显著减少后续麻烦。",
        ],
      },
    ],
  },
];

export const getArticle = (slug: string): Article | undefined =>
  articles.find((a) => a.slug === slug);

export const getArticlesByChannel = (channel: string): Article[] =>
  articles.filter((a) => a.channel === channel);

export const getFeaturedArticle = (): Article =>
  articles.find((a) => a.featured) ?? articles[0];